import React from 'react';

import styled from 'styled-components';

import SupportConfigForm from '../organisms/SupportConfigForm';

const TermsOfUsePageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 40px;

  h1 {
    font-size: 24px;
    margin-bottom: 30px;
  }

  h2 {
    font-size: 18px;
    font-weight: bold;
  }

  section {
    margin-bottom: 30px;
  }

  ul {
    list-style-type: square;
    padding-left: 35px;
  }

  table {
    max-width: 1100px;
  }

  table, th, td {
    border:1px solid black;
    padding: 10px;
    text-align: center;
  }
`;
const DateWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
`;

const PrivacyPolicyPage = () => {
  return (
    <TermsOfUsePageWrapper>
      <h1>POLÍTICA DE PRIVACIDADE - MOVE</h1>
      <p>
        <section>
          <h2>1. Informações gerais</h2>
          <p>Nós estamos cientes do quão importante é a sua privacidade. Por isso, sabemos da nossa responsabilidade ao lidar com os seus dados pessoais.</p>
          <p>É por isso que, atentos às disposições da Lei Geral de Proteção de Dados (LGPD), a lei n. 13.709,
          de 14 de agosto de 2018, ao elaborarmos essa Política de Privacidade assumimos uma missão:
          tratar os seus dados pessoais de forma que seja evitada qualquer perda, alteração, roubo ou
        qualquer outra forma de uso que não esteja de acordo com essa Política de Privacidade.</p>
          <p>Para utilizar nossa solução, você deverá fornecer alguns dados pessoais. Esses dados pessoais
          podem variar de acordo com a exigência de nossos clientes. Isso porque, enquanto
          controladores dos dados, são eles quem define os dados coletados, as finalidades, período de
          armazenamento etc; a Move, por outro lado, enquanto operadora dos dados pessoais, age
        somente em nome do controlador.</p>
        </section>

        <section>
          <h2>2. Direitos do usuário</h2>
          <p>Garantimos que o tratamento dos seus dados pessoais observará os seguintes princípios:</p>
          <ul>
            <li>Os dados pessoais do usuário serão processados de forma lícita, leal e transparente
              (licitude, lealdade e transparência);</li>
            <li>Os dados pessoais do usuário serão coletados apenas para finalidades determinadas,
            explícitas e legítimas, não podendo ser tratados posteriormente de uma forma
            incompatível com essas finalidades (limitação das finalidades);</li>
            <li>Os dados pessoais do usuário serão coletados de forma adequada, pertinente e limitada
            às necessidades do objetivo para os quais eles são processados (minimização dos dados);</li>
            <li>Os dados pessoais do usuário serão exatos e atualizados sempre que necessário, de
            maneira que os dados inexatos sejam apagados ou retificados quando possível (exatidão);</li>
            <li>Os dados pessoais do usuário serão conservados de uma forma que permita a
            identificação dos titulares dos dados apenas durante o período necessário para as
            finalidades para as quais são tratados (limitação da conservação);</li>
            <li>Os dados pessoais do usuário serão tratados de forma segura, protegidos do tratamento
            não autorizado ou ilícito e contra a sua perda, destruição ou danificação acidental,
            adotando as medidas técnicas ou organizativas adequadas (integridade e
            confidencialidade).</li>
          </ul>
          <p>Você possui os seguintes direitos, em relação aos seus dados pessoais, os quais deverão ser
          exercidos em face do Controlador dos dados pessoais, a quem caberá a ponderação sobre o
          seu deferimento ou não:</p>

          <ul>
            <li><b>Direito de confirmação e acesso:</b> é o direito do usuário de obter do site a confirmação
            de que os dados pessoais que lhe digam respeito são ou não objeto de tratamento e, se
            for esse o caso, o direito de acessar os seus dados pessoais;</li>
            <li><b>Direito de retificação:</b> é o direito do usuário de obter do site a retificação dos dados
            pessoais inexatos que lhe digam respeito;</li>
            <li><b>Direito à eliminação dos dados:</b> é o direito do usuário de ter seus dados apagados do
            site, observando-se as exceções previstas em lei;</li>
            <li><b>Direito à limitação do tratamento dos dados:</b> é o direito do usuário de limitar o
            tratamento de seus dados pessoais, podendo obtê-la quando contesta a exatidão dos
            dados, quando o tratamento for ilícito, quando o site não precisar mais dos dados para
            as finalidades propostas e quando tiver se oposto ao tratamento dos dados e em caso de
            tratamento de dados desnecessários;</li>
            <li><b>Direito de oposição:</b> é o direito do usuário de, a qualquer momento, se opor por motivos
            relacionados com a sua situação particular, ao tratamento dos dados pessoais que lhe
            digam respeito, podendo se opor ainda ao uso de seus dados pessoais para definição de
            perfil de marketing (profiling);</li>
            <li><b>Direito de portabilidade dos dados:</b>  é o direito do usuário de receber os dados pessoais
            que lhe digam respeito e que tenha fornecido ao site, num formato estruturado, de uso
            corrente e de leitura automática, e o direito de transmitir esses dados a outro site;</li>
            <li><b>Direito de revogação do consentimento:</b> direito dado ao titular pelo qual é permitida a
            revogação do consentimento, observadas as disposições legais.</li>
          </ul>

          <p>
            Esses direitos podem ser exercidos por meio de comunicação escrita enviada ao Controlador.
            Contudo, caso você não consiga enviá-lo, poderá nos contatar através do seguinte endereço:
            contato@use-move.com.
          </p>
        </section>

        <section>
          <h2>3. Informações coletadas</h2>
          <p>
            A coleta de dados dos usuários se dará em conformidade com o disposto nesta Política de
            Privacidade, com base no disposto no artigo 7 da LGPD.
          </p>
          <p>Todos os dados coletados e/ou fornecidos são tratados como confidenciais e somente
            usaremos para fins aqui dispostos e/ou autorizados por você/Controlador.</p>
          <p>Os dados são coletados conforme definido pelo Controlador. Entretanto, ordinariamente, tais
          dados podem ser coletados:</p>
          <table>
            <tr>
              <th>DADOS PESSOAIS</th>
              <th>FINALIDADE</th>
            </tr>
            <tr>
              <td><b>Dados Pessoais para Contato</b><br />Nome, E-mail e Senha</td>
              <td>Tais dados visam apenas facilitar o contato, uma vez que seja
              requerido por você.<br />Utilizamos esses dados a fim de permitir um atendimento
              personalizado, e em caso de recuperação de senha.</td>
            </tr>
            <tr>
              <td><b>Dados Pessoais de Utilização</b><br />Endereço IP, Data/Hora, Página acessada, Navegador utilizado e Sistema Operacional</td>
              <td>Estes são os dados pessoais coletados sobre você quando acessa
              nosso website, com a finalidade de melhorar nossos conteúdos e serviços. </td>
            </tr>
            <tr>
              <td><b>Dados Pessoais para Transações Financeiras</b><br />Dados de Cartão de Crédito</td>
              <td>Estes dados são solicitados somente nas recargas pagas, e são
              enviados diretamente para o serviço de pagamentos Mercado
              Pago.<br />Em nenhuma hipótese tais dados são armazenados ou utilizados
              pela MOVE.</td>
            </tr>
          </table>
          <p>Caberá ao Controlador, de acordo com as disposições da Lei Geral de Proteção de Dados, dar
          transparência aos demais aspectos do tratamento: finalidade, período de retenção etc.</p>
          <p>Adicionalmente, poderemos utilizar os dados pessoais a que tivermos de forma anonimizada,
          garantindo, desta maneira, que não haja a identificação do titular dos dados pessoais.</p>
        </section>

        <section>
          <h2>4. Alterações na presente política</h2>
          <p>Nos reservamos o direito de alterar essa Política quantas vezes forem necessárias, visando
          fornecer a você cada vez mais segurança e conveniência.</p>
          <p>Para facilitar, sempre indicaremos no fim do documento a data da última atualização, e se
          alterações substanciais forem feitas, notificaremos você sobre tais alterações antes que
          entrem em vigor. </p>
        </section>

        <section>
          <h2>5. Dados pessoais de menores</h2>
          <p>A coleta de dados pessoais de menores (crianças e adolescentes), depende do respectivo
          cumprimento das obrigações legais da Lei Geral de Proteção de Dados neste particular. Neste
          caso, cabe ao Controlador o cumprimento de tais obrigações.</p>
          <p>De toda forma, se você é responsável de algum menor, pode entrar em contato conosco
          através do nosso e-mail: contato@use-move.com.</p>
        </section>

        <section>
          <h2>6. Compartilhamento ou Divulgação de Dados Pessoais</h2>
          <p>As informações coletadas são de nosso uso exclusivo para as finalidades aqui referidas, bem
          como às elencadas pelo Controlador, portanto, não serão vendidas a terceiros</p>
          <p>No entanto, podemos divulgar os seus dados pessoais na crença de boa fé de que tal ação é
          necessária para:</p>
          <p><b>Conformidade legal.</b> Compreendendo (i) processos e requisições legais; (ii) estabelecimento
          ou exercício de nossos direitos legais ou defesa em processos judiciais; ou (iii) conforme
          requerido por lei; e</p>
          <p><b>Prestação de Serviços por Terceiros.</b> Podemos, ainda, atuar em conjunto com outras empresas
          em diversas atividades para facilitar o nosso serviço, para executar serviços relacionados ao
          Site e/ou evento, ou, ainda, para nos auxiliar na análise de como nosso serviço é utilizado.
          Esses terceiros, contudo, têm acesso aos seus dados pessoais somente para realizar essas
          tarefas em nosso nome e são obrigados não os divulgar ou usar para qualquer outra finalidade.</p>
        </section>

        <section>
          <h2>7. Responsável pelo tratamento de dados pessoais</h2>
          <p>Neste site, o responsável pelo tratamento dos dados pessoais coletados é a <b>MOVE SOLUÇÕES
          EM ELETROMOBILIDADE LTDA</b>., sociedade empresarial limitada, inscrita no CNPJ sob nº
          29.668.246/0001-18, com sede Rua Irmão Calixto, 31, Sala 204, Saco dos Limões, Florianópolis
          - SC, 88040-605.</p>
        </section>

        <section>
          <h2>8. Segurança no tratamento dos dados pessoais do usuário</h2>
          <p>O site se compromete a aplicar as medidas técnicas e organizativas aptas a proteger os dados
          pessoais de acessos não autorizados e de situações de destruição, perda, alteração,
          comunicação ou difusão de tais dados.</p>
          <p>Para a garantia da segurança, serão adotadas soluções que levem em consideração: as
          técnicas adequadas; os custos de aplicação; a natureza, o âmbito, o contexto e as finalidades
          do tratamento; e os riscos para os direitos e liberdades do usuário.</p>
        </section>

        <section>
          <h2>9. Do Direito aplicável e do foro</h2>
          <p>Para a solução das controvérsias decorrentes do presente instrumento será aplicado
          integralmente o Direito brasileiro.</p>
          <p>Os eventuais litígios referentes às matérias aqui tratadas deverão ser apresentados na
          comarca de Florianópolis/SC.</p>
        </section>

        <section>
          <h2>10. Transferência internacional</h2>
          <p>Os dados armazenados em nossa Plataforma estão armazenados em servidor AWS, nos EUA.
          Tais dados estão armazenados em ambiente seguro, de forma criptografada.</p>
          <p>Adotamos, além disso, uma série de medidas técnicas e organizacionais para proteção da
          confidencialidade, integridade e disponibilidade dos dados pessoais a que temos acesso.</p>
        </section>

        <section>
          <h2>10. Obrigado por ler nossa Política de Privacidade!</h2>
          <p>Estaremos sempre à disposição para atendê-lo. Se você desejar obter mais informações, ou
          caso tenha restado alguma dúvida sobre essa Política, por favor, entre em contato conosco.</p>
        </section>

        <DateWrapper>
          <p>Última atualização: 29 de setembro de 2021.</p>
        </DateWrapper>
      </p>
    </TermsOfUsePageWrapper>
  );
};

export default PrivacyPolicyPage;
